import React, { useRef, useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import classes from "./Notifications.module.css";
import PageLayout from "../../PageLayout/PageLayout";
import { Notify } from "../../../../../constant/imagePath";
import { Button } from "../../../../../stories/Button/Button";
import { Switch } from "../../../../../stories/Switch/Switch";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import NotificationsMobile from "./NotificationsMobile";

const NotificationsDesktop = () => {
  const _noti = [
    {
      title: "Someone message me",
      email: false,
      desktopAndMobile: false,
    },
    {
      title: "Anyone left me a review",
      email: false,
      desktopAndMobile: false,
    },
    {
      title: "Anyone cancelled the lesson",
      email: false,
      desktopAndMobile: false,
    },
    {
      title: "Anyone accept or decline the lesson",
      email: false,
      desktopAndMobile: false,
    },
    {
      title: "Get Lytesnap news, announcements, and product updates",
      email: false,
      desktopAndMobile: false,
    },
  ];
  const [notificationarray, setNotificationarray] = useState(_noti);

  // UpdateNotificationsValues
  const handleUpdateNotificationsValues = (item, i, type = "email") => {
    const notificationarrayCopy = [...notificationarray];
    if (type == "email") notificationarrayCopy[i].email = !item?.email;
    if (type == "dAm")
      notificationarrayCopy[i].desktopAndMobile = !item?.desktopAndMobile;

    setNotificationarray(notificationarrayCopy);
  };

  return (
    <div className={[classes.NotificationScreen].join(" ")}>
      <Container fluid className={[classes.container, "p-0"].join(" ")}>
        <Row className={["g-0"].join(" ")}>
          <Col md={12} className={[classes.mb52].join(" ")}>
            <h3
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
              }}
            >
              Profile Settings
            </h3>
          </Col>
          <Col md={12} className={[classes.mb52].join(" ")}>
            <div
              className={[
                classes.notifydiv,
                classes.dflex,
                classes.itemscenter,
                classes.contentbetween,
              ].join(" ")}
            >
              <div className={[classes.dflex].join(" ")}>
                <img
                  src={Notify}
                  alt="..."
                  className={[classes.notifyimg, classes.mr24].join(" ")}
                />
                <div>
                  <h5
                    style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
                    className={[classes.mb4].join(" ")}
                  >
                    You need to allow permission for notifications
                  </h5>
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    You need to allow permission for notifications
                  </p>
                </div>
              </div>
              <div className={[classes.notifybtn].join(" ")}>
                <Button
                  primary={false}
                  customStyle={{ width: "max-content" }}
                  size="Large"
                >
                  Allow notiifications
                </Button>
              </div>
            </div>
          </Col>
          <Col md={12}>
            <Table
              striped={false}
              bordered={false}
              hover={false}
              responsive
              className={[classes.notifytable].join(" ")}
            >
              <thead>
                <tr>
                  <th
                    style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
                    className={[classes.pb32].join(" ")}
                  >
                    Notify me when:
                  </th>
                  <th
                    style={{
                      ...Fonts.h7,
                      color: Colors.neutralShadesOfNero,
                      lineHeight: "24px",
                    }}
                    className={[classes.textcenter, classes.pb32].join(" ")}
                  >
                    Email
                  </th>
                  <th
                    style={{
                      ...Fonts.h7,
                      color: Colors.neutralShadesOfNero,
                      lineHeight: "24px",
                    }}
                    className={[classes.textcenter, classes.pb32].join(" ")}
                  >
                    Desktop and mobile
                  </th>
                </tr>
              </thead>
              <tbody>
                {notificationarray.map((item, i) => {
                  return (
                    <tr
                      key={i}
                      style={{
                        borderTop: i == 4 && "1px solid #DDDDDD",
                      }}
                    >
                      <td
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfDimGray,
                          padding:
                            (i === 4 && "48px  0px 32px 0px") ||
                            (i === 3 && "0px  0px 48px 0px"),
                        }}
                        className={[i !== 4 && i !== 3 && classes.pb32].join(
                          " "
                        )}
                      >
                        {item?.title}
                      </td>
                      <td
                        style={{
                          padding:
                            (i === 4 && "48px 0px 32px 0px") ||
                            (i === 3 && "0px  0px 48px 0px"),
                        }}
                        className={[
                          classes.textcenter,
                          i !== 4 && i !== 3 && classes.pb32,
                        ].join(" ")}
                      >
                        <Switch
                          value={item?.email}
                          setter={() =>
                            handleUpdateNotificationsValues(item, i)
                          }
                        />
                      </td>
                      <td
                        style={{
                          padding:
                            (i === 4 && "48px  0px 32px 0px") ||
                            (i === 3 && "0px  0px 48px 0px"),
                        }}
                        className={[
                          classes.textcenter,
                          i !== 4 && i !== 3 && classes.pb32,
                        ].join(" ")}
                      >
                        <Switch
                          value={item?.desktopAndMobile}
                          setter={() =>
                            handleUpdateNotificationsValues(item, i, "dAm")
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const Notification = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <NotificationsMobile /> : <NotificationsDesktop />;
};

export default Notification;
